/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

// eslint-disable-next-line max-len
const emailRegExp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
const userGroupRegExp = /^%[^%]+%([,;] ?%[^%]+%)*$/;

const emailValidator = (
    value: string,
    { multipleEmailsError, wrongEmailFormatError }: { multipleEmailsError: string; wrongEmailFormatError: string; }
): string | void => {
    const items = value.split(/[;,]/);

    if (items.length > 1) {
        return multipleEmailsError;
    }

    if (!value.trim().match(emailRegExp) || value.trim().match(/\s+/)) {
        return wrongEmailFormatError;
    }
};

const emailOrUserGroupListValidator = (value: string, { wrongFormatError }: { wrongFormatError: string; }): string | void => {
    const items = value.split(/[;,]/);
    let result = '';

    items.forEach((item) => {
        const val = item.trim();

        if (!val.match(emailRegExp) && !val.match(userGroupRegExp)) {
            result = wrongFormatError;
        }
    });

    if (result) {
        return result;
    }
};

export {
    emailRegExp,
    emailValidator,
    emailOrUserGroupListValidator,
};
